import React from 'react';

import 'whatwg-fetch';
import { Link } from 'react-router-dom';
import moment from 'moment';

import data_criticity from 'src/data/criticity';
import data_priority from 'src/data/priority';
import data_ticket_state from 'src/data/ticket-state';
import data_task_state from 'src/data/planning-state';

import { deleteEntity } from 'src/utils/entityApi';
import ModalConfirm from '../../components/modal/modalConfirm';

import eyeIcon from 'src/images/eye.svg';
import ringAnim from 'src/images/anim/ring.svg';
import Card from 'src/components/Card';
import { Link as MaterialLink, Typography } from '@material-ui/core';
import { MdWarning as WarningIcon } from '@react-icons/all-files/md/MdWarning';
import withAuth from 'src/hoc/withAuth';

const modulesThatCanExpire = ['tasks', 'reminders', 'appointments'];

class DashletList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dashletInfo: undefined,
      dashletParsed: false,
      hasMore: true,
      pendingFetch: false,
      offset: 0,
      requestGraphQL: undefined,
      dataToDisplay: undefined,
      dataToDisplayParsed: undefined,
      dataFiles: {
        data_criticity: data_criticity,
        data_priority: data_priority,
        data_ticket_state: data_ticket_state,
        data_task_state: data_task_state,
      },
      isModalDeleteDashletOpen: false,
      textModal: {
        title: 'Suppression Dashlet',
        message: 'Vous allez supprimer le dashlet',
      },
    };

    this.seeMore = this.seeMore.bind(this);
    this.openModalDeleteDashlet = this.openModalDeleteDashlet.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.update = this.update.bind(this);
  }

  /*
        When the component receive Dashlet Information in props
     */
  componentDidMount() {
    let dashlet = this.props.dashletInfo;

    if (dashlet && !this.state.dashletParsed) {
      if (typeof dashlet.metadata === 'string') {
        //Necessary when you switch dashboard and return
        dashlet.metadata = JSON.parse(dashlet.metadata);
      }

      if (dashlet.metadata.displayColumns && modulesThatCanExpire.includes(dashlet.metadata.module.graphQl)) {
        let expiredColumnAlreadyExist =
          -1 !== dashlet.metadata.displayColumns.findIndex((columns) => columns.model === 'expired');

        if (!expiredColumnAlreadyExist) {
          // Used to display warning icon on expired row
          dashlet.metadata.displayColumns.unshift({
            model: 'expired',
            label: '',
            type: 'boolean',
            graphQlArgument: 'expired',
            graphQlLink: 'expired',
          });
        }
      }

      this.setState({ dashletInfo: dashlet, dashletParsed: true });
      this.buildRequest(dashlet, this.state.offset);
    }
  }

  update() {
    this.props.onUpdate(this.state.dashletInfo);
  }

  getPositionOfColumn(columnName) {
    let position;
    if (this.state.dashletInfo) {
      let myDashlet = this.state.dashletInfo;

      for (let i = 0; i < myDashlet.metadata.displayColumns.length; i++) {
        if (myDashlet.metadata.displayColumns[i].model === columnName) {
          position = i;
        }
      }
    }

    return position;
  }

  /*
        Parse the data received in order to display it for any type of entities
    */
  parseDataToDisplay(data) {
    //Contains all the rows of the dashlet
    let myArray = [];

    /*
            BE CAREFUL !!!!!!
            If the element is required for different attributes in the GraphQL response :
            ex: For a deal PDC and commercialEmployee
            the response will be presented like that
            -> stepCommercial:
                commercialEmployee: ....
                pdc: ...

         */
    let positionCommercialEmployee = this.getPositionOfColumn('commercialEmployee');
    let positionPDC = this.getPositionOfColumn('pdc');
    if (
      this.state.dashletInfo &&
      this.state.dashletInfo.metadata.module.name === 'Affaires' &&
      positionCommercialEmployee !== undefined &&
      positionPDC !== undefined
    ) {
      for (let i = 0; i < data.length; i++) {
        if (data[i] && data[i].stepCommercial2 === undefined) {
          /* We need to check which one is displayed first */
          if (positionPDC > positionCommercialEmployee) {
            data[i].stepCommercial2 = data[i].stepCommercial.proposition;
            delete data[i].stepCommercial.proposition;
            let keys = Object.keys(data[i]);

            if (positionPDC < keys.length - 1) {
              let newObject = {};
              newObject.id = data[i].id;
              for (let j = 1; j < keys.length - 1; j++) {
                newObject[keys[j]] = data[i][keys[j]];
              }

              newObject.stepCommercial2 = data[i].stepCommercial2;
              newObject[keys[keys.length - 2]] = data[i][keys[keys.length - 2]];
              data[i] = newObject;
            }
          } else {
            data[i].stepCommercial2 = data[i].stepCommercial.commercialEmployee;
            delete data[i].stepCommercial.commercialEmployee;
            let keys = Object.keys(data[i]);

            if (positionCommercialEmployee < keys.length - 1) {
              let newObject = {};
              newObject.id = data[i].id;

              for (let j = 1; j < keys.length - 1; j++) {
                newObject[keys[j]] = data[i][keys[j]];
              }

              newObject.stepCommercial2 = data[i].stepCommercial2;
              newObject[keys[keys.length - 2]] = data[i][keys[keys.length - 2]];
              data[i] = newObject;
            }
          }
        }
      }
    }

    /* After the check of stepCommercial issue we can parse the rest of data */
    for (let i = 0; i < data.length; i++) {
      if (data[i]) {
        let keys = Object.keys(data[i]);

        //This object represents a row in the dashlet -> the id for the eyeIcon, elements for the table tds
        let lineEntity = {
          id: null,
          elements: null,
        };

        let myLineElements = [];
        for (let j = 0; j < keys.length; j++) {
          let element = {
            id: null,
            value: null,
          };

          if (null !== data[i][keys[j]] && undefined !== data[i][keys[j]]) {
            let subKeys = Object.keys(data[i][keys[j]]);
            // If the element is an object we need to explore it deeper
            if (typeof data[i][keys[j]] === 'object' && subKeys.length > 1) {
              for (let subKey of subKeys) {
                if (subKey !== 'id' && data[i][keys[j]][subKey]) {
                  element.value = this.parseLine(data[i][keys[j]][subKey], null);
                } else if (subKey === 'id' && data[i][keys[j]][subKey]) {
                  element.id = this.parseLine(data[i][keys[j]][subKey], null);
                }
              }
            } else {
              if (
                keys[j] === 'priority' ||
                keys[j] === 'criticity' ||
                keys[j] === 'state' ||
                keys[j] === 'stateId' ||
                keys[j] === 'dateCreate' ||
                keys[j] === 'dateClosed' ||
                keys[j] === 'dateRecall' ||
                keys[j] === 'deadline' ||
                keys[j] === 'closingDate' ||
                (keys[j] === 'desiredClotureDate' && data[i][keys[j]] !== null)
              ) {
                element.value = this.parseLine(data[i][keys[j]], keys[j]);
              } else if (
                keys[j] !== 'id' &&
                (keys[j] !== 'priority' || keys[j] !== 'criticity' || keys[j] !== 'state') &&
                data[i][keys[j]] !== null
              ) {
                element.value = this.parseLine(data[i][keys[j]], null);
              } else if (keys[j] === 'id' && data[i][keys[j]] !== null) {
                lineEntity.id = this.parseLine(data[i][keys[j]], null);
              }
            }
          } else {
            element.value = '_____';
          }

          if (element.value !== null) {
            myLineElements.push(element);
          }
        }

        //Pass the elements to the lineEntity
        lineEntity.elements = myLineElements;

        if (lineEntity.elements && lineEntity.elements.length > 0) {
          myArray.push(lineEntity);
        }
      }
    }

    this.setState({
      dataToDisplayParsed: myArray,
    });
  }

  /*
        This recursive function return the last value of a composed object
     */
  parseLine(value, key) {
    if (value !== null) {
      if (typeof value !== 'object' && typeof value !== 'boolean') {
        if (key) {
          switch (key) {
            case 'priority':
              return this.state.dataFiles.data_priority[value]['fr'];
              break;
            case 'criticity':
              return this.state.dataFiles.data_criticity[value]['fr'];
              break;
            case 'state':
            case 'stateId':
              if (this.state.dashletInfo.metadata.module.name === 'Tickets') {
                return this.state.dataFiles.data_ticket_state[value]['fr'];
              } else {
                return this.state.dataFiles.data_task_state[value]['fr'];
              }
              break;
            case 'dateCreate':
              return moment(value).format('DD-MM-YYYY');
              break;
            case 'dateClosed':
              return moment(value).format('DD-MM-YYYY');
              break;
            case 'desiredClotureDate':
              return moment(value).format('DD-MM-YYYY');
              break;
            case 'dateRecall':
              return moment(value).format('DD-MM-YYYY HH:mm');
              break;
            case 'deadline':
              return moment(value).format('DD-MM-YYYY');
              break;
            case 'closingDate':
              return moment(value).format('DD-MM-YYYY');
              break;
            default:
              break;
          }
        } else {
          return value;
        }
      } else if (typeof value === 'boolean') {
        return value ? 'Oui' : 'Non';
      } else {
        return this.parseLine(value[Object.keys(value)[0]]);
      }
    } else {
      return '____';
    }
  }

  /*
        This method is called after the component has received his props.
        It builds the graphQL query that will be sent to the controller of the module.

        ex : { deals(offset:0, limit:10){ items{id, name}, hasMore }}
     */
  buildRequest(dashletInfo, offset) {
    let myDashlet = dashletInfo ? dashletInfo : this.state.dashletInfo;

    //Start
    let requestGraphQL = '';
    requestGraphQL += myDashlet.metadata.module.apiRequest;
    requestGraphQL += '{';
    requestGraphQL += myDashlet.metadata.module.graphQl;

    //Parameters
    requestGraphQL += '(';

    /*
            Order by -> attribute + direction
         */
    requestGraphQL += 'orderBy:"' + myDashlet.metadata.orderBy.column.model + '",';
    requestGraphQL += 'ASC:' + (myDashlet.metadata.orderBy.orderDirection !== 'DESC' ? true : false);
    requestGraphQL += ',';
    /*
            Offset + Limit
         */
    requestGraphQL += 'offset:' + offset + ',';
    requestGraphQL += 'limit:' + myDashlet.metadata.nbRows;

    let filterKeys = Object.keys(myDashlet.metadata.filters);
    if (filterKeys.length > 0) requestGraphQL += ',';

    for (let [key, filter] of Object.entries(myDashlet.metadata.filters)) {
      if (!filter || !filter.columnSelected) {
        continue;
      }

      if (filter.columnSelected.type === 'date') {
        requestGraphQL += filter.columnSelected.graphQlArgument + 'Operator';
        requestGraphQL += ':';
        requestGraphQL += '"' + filter.operatorSelected.label + '"';

        if (filter.operatorSelected.nbParam >= 1) {
          requestGraphQL += ',';
          requestGraphQL += filter.columnSelected.graphQlArgument + 'Start';
          requestGraphQL += ':"';
          requestGraphQL += filter.param1;
          requestGraphQL += '"';
        }
        if (filter.operatorSelected.nbParam === 2) {
          requestGraphQL += ',';
          requestGraphQL += filter.columnSelected.graphQlArgument + 'End';
          requestGraphQL += ':"';
          requestGraphQL += filter.param2;
          requestGraphQL += '"';
        }
      } else if (filter.columnSelected.type === 'numeric') {
        /*
                Number
            */
        requestGraphQL += filter.columnSelected.graphQlArgument + 'Operator';
        requestGraphQL += ':';
        requestGraphQL += '"' + filter.operatorSelected.label + '"';

        if (filter.operatorSelected.nbParam >= 1) {
          requestGraphQL += ',';
          requestGraphQL += filter.columnSelected.graphQlArgument + 'Start';
          requestGraphQL += ':';
          requestGraphQL += filter.param1;
        }
        if (filter.operatorSelected.nbParam === 2) {
          requestGraphQL += ',';
          requestGraphQL += filter.columnSelected.graphQlArgument + 'End';
          requestGraphQL += ':';
          requestGraphQL += filter.param2;
        }
      } else if (
        /*
                Text, picklist
            */
        filter.columnSelected.type === 'text' ||
        filter.columnSelected.type === 'picklist'
      ) {
        requestGraphQL += filter.columnSelected.graphQlArgument + 'Operator';
        requestGraphQL += ':';
        requestGraphQL += '"' + filter.operatorSelected.label + '"';

        requestGraphQL += ',';

        requestGraphQL += filter.columnSelected.graphQlArgument;
        requestGraphQL += ':';

        if (filter.columnSelected.type === 'picklist' && !filter.columnSelected.dataFile) {
          requestGraphQL += '[';
          for (let i = 0; i < filter.param1.length; i++) {
            requestGraphQL += filter.param1[i]['id'];
            if (i !== filter.param1.length - 1) {
              requestGraphQL += ',';
            }
          }

          requestGraphQL += ']';
        } else if (
          /*
                    This block concerns dataFiles picklists like state, priority or deal steps
                 */
          filter.columnSelected.type === 'picklist' &&
          filter.columnSelected.dataFile
        ) {
          if (filter.columnSelected.multi) {
            requestGraphQL += '[';
            for (let i = 0; i < filter.param1.length; i++) {
              requestGraphQL += filter.param1[i]['value'];
              if (i !== filter.param1.length - 1) {
                requestGraphQL += ',';
              }
            }
            requestGraphQL += ']';
          } else {
            requestGraphQL += filter.param1['value'];
          }
        } else {
          requestGraphQL += '"' + filter.param1 + '"';
        }
      } else if (filter.columnSelected.type === 'boolean') {
        requestGraphQL += filter.columnSelected.graphQlArgument;
        requestGraphQL += ':';
        requestGraphQL += filter.operatorSelected.label === 'Oui';
      }

      if (key !== filterKeys[filterKeys.length - 1]) {
        requestGraphQL += ',';
      }
    }

    requestGraphQL += ')';
    //end parameters

    // Id of the entity + attributes we want
    requestGraphQL += '{';
    requestGraphQL += 'items{ id, ';
    for (let i = 0; i < myDashlet.metadata.displayColumns.length; i++) {
      requestGraphQL += myDashlet.metadata.displayColumns[i].graphQlLink;
      if (i !== myDashlet.metadata.displayColumns.length - 1) {
        requestGraphQL += ',';
      }
    }
    requestGraphQL += '}';
    requestGraphQL += ',';

    //hasMore
    requestGraphQL += 'hasMore';

    requestGraphQL += '}';

    //End
    requestGraphQL += '}';

    this.setState({
      requestGraphQL: requestGraphQL,
    });

    this.refreshData(requestGraphQL, offset);
  }

  seeMore() {
    let newOffset = this.state.offset + this.state.dashletInfo.metadata.nbRows;
    this.buildRequest(this.state.dashletInfo, newOffset);
    this.setState({
      offset: newOffset,
    });
  }

  openModalDeleteDashlet() {
    this.props.toggleBlackOut();
    this.setState({
      isModalDeleteDashletOpen: true,
    });
  }

  closeModal() {
    this.setState({
      isModalDeleteDashletOpen: false,
      isModalDashletOpen: false,
    });
    this.props.toggleBlackOut();
  }

  postResult(type, promise) {
    promise.then(
      function (result) {
        if (result.wentFine) {
          this.props.openToast(true, 'Succès supression ' + type);
          this.props.onDelete();
        } else {
          this.props.openToast(false, 'Erreur suppression ' + type + '. Veuillez réessayer');
        }
      }.bind(this)
    );
  }

  getColorByTicketState(state) {
    for (let ticketState of Object.keys(data_ticket_state)) {
      if (data_ticket_state[ticketState].fr === state) {
        return data_ticket_state[ticketState].color;
      }
    }
  }

  refreshData(query, offset) {
    this.props
      .authFetch(query, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then((data) => {
        let dataToDisplay =
          offset > 0
            ? this.state.dataToDisplay.concat(data['data'][this.state.dashletInfo.metadata.module.graphQl]['items'])
            : data['data'][this.state.dashletInfo.metadata.module.graphQl]['items'];

        this.setState({
          dataToDisplay,
          hasMore: data['data'][this.state.dashletInfo.metadata.module.graphQl]['hasMore'],
        });

        this.parseDataToDisplay(dataToDisplay);
      })
      .catch((error) => {
        console.log('erreur fetch data dashlet list\n' + error);
      });
  }

  render() {
    return (
      <Card style={{ display: 'block' }} className='dashlet'>
        <Typography variant='h6'>{this.state.dashletInfo ? this.state.dashletInfo.title : 'Chargement'}</Typography>
        <MaterialLink component='button' onClick={() => this.buildRequest(this.state.dashletInfo, this.state.offset)}>
          Rafraîchir
        </MaterialLink>
        {` - `}
        <MaterialLink component='button' onClick={this.update}>
          Editer
        </MaterialLink>

        {this.state.dashletInfo && (
          <button
            onClick={this.openModalDeleteDashlet}
            type='button'
            className='close dashlet-close'
            aria-label='Close'
          >
            <span aria-hidden='true'>&times;</span>
          </button>
        )}
        <div className='dashlet-content'>
          <div className='dashlet-table-container'>
            <table className='table fixed-header'>
              <thead>
                <tr>
                  {this.state.dashletInfo ? (
                    this.state.dashletInfo.metadata.displayColumns.map(
                      (column, key) =>
                        this.state.dashletInfo.metadata.displayColumns[key] &&
                        this.state.dashletInfo.metadata.displayColumns[key].model !== 'expired' && (
                          <th className='dashlet-table-head' key={key}>
                            {column.label}
                          </th>
                        )
                    )
                  ) : (
                    <th>Chargement...</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {this.state.dataToDisplayParsed ? (
                  this.state.dataToDisplayParsed.map((line, i) => (
                    <tr key={i} className='dashlet-table-cell'>
                      {line.elements.map((element, j) =>
                        this.state.dashletInfo.metadata.displayColumns[j] &&
                        this.state.dashletInfo.metadata.displayColumns[j].routing &&
                        element.id ? (
                          <td key={j}>
                            <Link to={this.state.dashletInfo.metadata.displayColumns[j].routing + element.id}>
                              {element.value !== undefined ? element.value : '_____'}
                            </Link>
                          </td>
                        ) : this.state.dashletInfo.metadata.displayColumns[j] &&
                          this.state.dashletInfo.metadata.displayColumns[j].model === 'expired' ? (
                          <td key={j} style={{ maxWidth: 20, paddingRight: 0 }}>
                            {element.value === 'Oui' && (
                              <WarningIcon title='Deadline dépassée' color='#ffbc00' size={18} />
                            )}
                          </td>
                        ) : (
                          <td
                            key={j}
                            style={
                              this.state.dashletInfo.metadata.module.name === 'Tickets' &&
                              this.state.dashletInfo.metadata.displayColumns[j].model === 'stateId'
                                ? {
                                    borderLeft: '10px solid ' + this.getColorByTicketState(element.value),
                                  }
                                : { borderLeft: '0px' }
                            }
                          >
                            {element.value !== undefined ? element.value : '_____'}
                          </td>
                        )
                      )}
                      {line.id && this.state.dashletInfo.metadata.module.routing && (
                        <Link to={this.state.dashletInfo.metadata.module.routing + line.id}>
                          <img className={'iconSeeMore'} src={eyeIcon} alt='Voir plus' />
                        </Link>
                      )}
                    </tr>
                  ))
                ) : (
                  <tr>Chargement...</tr>
                )}
              </tbody>
            </table>
          </div>
          {this.state.hasMore && (
            <div className='list-see-more'>
              {this.state.pendingFetch ? (
                <img src={ringAnim} alt='' />
              ) : (
                <button onClick={this.seeMore} type='button' className='btn btn-sm btn-outline-success'>
                  <span className=''>Voir plus</span>
                </button>
              )}
            </div>
          )}
        </div>
        <ModalConfirm
          className='myModal'
          modalText={this.state.textModal}
          isOpen={this.state.isModalDeleteDashletOpen}
          onSubmit={(type, promise) =>
            this.postResult('dashlet', deleteEntity(this.props.authFetch, 'dashlet', this.state.dashletInfo.id))
          }
          onCancel={this.closeModal}
          onClose={this.closeModal}
        />
      </Card>
    );
  }
}

export default withAuth(DashletList);
